var _defs, _g, _text, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHillViewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9757",
    "data-name": "Group 9757",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.004,
    height: 125.739,
    viewBox: "0 0 69.004 125.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2660",
    "data-name": "Rectangle 2660",
    width: 69.004,
    height: 125.739,
    fill: "#f7f5ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9754",
    "data-name": "Group 9754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9753",
    "data-name": "Group 9753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M69,51.826c0,6.057.01,12.114,0,18.17a31.988,31.988,0,0,1-1.283,9.9,37.245,37.245,0,0,1-6.669,11.877,32.944,32.944,0,0,1-13.166,9.836,34.707,34.707,0,0,1-24.7.614,34.043,34.043,0,0,1-10.753-5.986,30.915,30.915,0,0,1-7.714-9.123,35.986,35.986,0,0,1-4.7-17.46c0-10.868.043-21.737-.014-32.6A42.4,42.4,0,0,1,1.8,23.653,37.487,37.487,0,0,1,7.251,13.559C12.1,6.763,18.91,3.219,26.743,1.074A29.1,29.1,0,0,1,39.832.482a38.37,38.37,0,0,1,9.191,2.8A34.931,34.931,0,0,1,63.756,16.236a31.1,31.1,0,0,1,5.18,16.741c.115,6.281.026,12.566.026,18.849H69m-67.559.235H1.384c0,6.058-.181,12.123.037,18.173.5,14,7.248,24.123,19.963,29.825,10.273,4.607,20.586,3.807,30.251-2.016,10.213-6.153,15.7-15.453,16.072-27.3.384-12.274.107-24.57.068-36.856a31.224,31.224,0,0,0-2.707-12.36C57.666,4.416,37.094-3.859,19.824,4.993,8.429,10.833,2.162,20.226,1.5,33.042c-.328,6.324-.057,12.679-.057,19.02",
    transform: "translate(0 -0.001)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M39.9,1613.281h3.343c-.973.5-.9,1.451-.9,2.388,0,1.928.035,4.122,0,6.138h2.813a4.984,4.984,0,0,1,4.653,3.167v-9.3c0-.991.106-1.875-.92-2.388h3.361c-.991.5-.92,1.433-.92,2.388v9.906c0,1.008-.088,1.875.92,2.37H48.945a1.831,1.831,0,0,0,.867-1.84,5.717,5.717,0,0,0-.283-1.044,4.693,4.693,0,0,0-4.369-2.937H42.346v3.45c0,.991-.088,1.893.92,2.37h-3.29c.9-.46.849-1.468.849-2.37v-9.906c0-.991.088-1.858-.92-2.388",
    transform: "translate(-37.166 -1502.561)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M226.33,1618.342h.106v8c0,.708-.018,1.574.655,2.017h-2.53c.655-.442.655-1.327.655-2.017v-3.98c0-.849.23-3.007-1.008-3.114Zm-1.327-3.75a.823.823,0,0,1,1.645,0,.8.8,0,0,1-.814.814.827.827,0,0,1-.831-.814",
    transform: "translate(-208.82 -1503.041)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M270.628,1602.227h.106v12.295a4.173,4.173,0,0,0,.159,1.415,1.459,1.459,0,0,0,.531.6h-2.547c.637-.425.637-1.345.637-2.017v-8.3a13.235,13.235,0,0,0-.088-2.176c-.106-.513-.336-.885-.885-.955Zm3.22-1.061h.124v13.356a3.758,3.758,0,0,0,.159,1.415,1.308,1.308,0,0,0,.513.6h-2.53a1.387,1.387,0,0,0,.46-.584,3.544,3.544,0,0,0,.177-1.433v-9.393a10.827,10.827,0,0,0-.088-2.158.991.991,0,0,0-.884-.955Z",
    transform: "translate(-250.111 -1491.277)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M598.026,1618.342h.106v8c0,.708-.018,1.574.655,2.017h-2.53c.655-.442.655-1.327.655-2.017v-3.98c0-.849.23-3.007-1.008-3.114Zm-1.327-3.75a.823.823,0,0,1,1.645,0,.8.8,0,0,1-.814.814.827.827,0,0,1-.831-.814",
    transform: "translate(-555.006 -1503.041)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M649.962,1679.5a10.506,10.506,0,0,1,2.353-.23h.619l-.265,2.194a3.465,3.465,0,0,1-4.953,3.078c.159,2.017,1.256,4.069,3.556,4.069a3.327,3.327,0,0,0,2.512-1.15,4.119,4.119,0,0,1-3.449,2.193c-2.547,0-3.91-2.423-3.91-4.723,0-2.282,1.114-4.829,3.538-5.431m-2.282,4.67a3.011,3.011,0,0,0,1.486.389,3.206,3.206,0,0,0,3.025-2.176,1.939,1.939,0,0,0-.8-2.141,2.707,2.707,0,0,0-1.327-.354c-1.787,0-2.388,2.707-2.388,4.1Z",
    transform: "translate(-602.06 -1564.019)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M751.849,1684.939h2.618c-.584.371-.371,1.221-.159,1.734l2.406,6.368,1.751-3.733a1.1,1.1,0,0,1,1.008-.708,1.35,1.35,0,0,1,.371.053l-1.026-2.618a2.132,2.132,0,0,0-.849-1.1h2.671a1.166,1.166,0,0,0-.442,1.539l2.53,6.368,2.583-6.7c.212-.584.424-.778-.106-1.185,0-.018,0-.018-.018-.018h1.468a2.508,2.508,0,0,0-1.008,1.274l-3.361,8.721-2.264-5.82a.819.819,0,0,0-.531-.23.9.9,0,0,0-.761.619l-2.512,5.378L753,1686.443a2.423,2.423,0,0,0-1.15-1.5",
    transform: "translate(-700.249 -1569.301)",
    fill: "#f7f5ef"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "H",
    transform: "translate(20.555 50.983)",
    fill: "#f7f5ef",
    fontSize: 36,
    fontFamily: "Rawgly-Regular, Rawgly"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9756",
    "data-name": "Group 9756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9755",
    "data-name": "Group 9755",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M303.458,847.316c1.989.8,1.912,2.907,1.186,4.589l-3.633,8.49v-.006l-1.938,4.517h0c-.091.214-.184.431-.28.653l-3.939,9.1-6.807-16.292c-.807-1.964-2.769-5.983-3.09-8.26h0c-.688-2.715,3.084-2.825,3.492-2.829l-10.153.037c2.142.956,3.136,3.366,3.977,5.354l11.282,27L305.332,852.1c.65-1.645,1.8-4.092,3.6-4.781Z",
    transform: "translate(-259.194 -789.13)",
    fill: "#f7f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M414.5,1613.3c.922.372.887,1.348.55,2.128l-1.685,3.937v0l-.9,2.094h0c-.042.1-.085.2-.13.3l-1.826,4.22-3.156-7.554a21.342,21.342,0,0,1-1.433-3.83h0c-.319-1.259,1.43-1.31,1.619-1.312l-4.707.017a4.287,4.287,0,0,1,1.844,2.483l5.231,12.519,5.462-12.785c.3-.763.833-1.9,1.667-2.217Z",
    transform: "translate(-375.188 -1502.561)",
    fill: "#f7f5ef"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHillViewLogo);
export default __webpack_public_path__ + "static/media/hill_view_logo.8e9f1ab5dad0b07454449748dbd679e7.svg";
export { ForwardRef as ReactComponent };